import React from 'react';

/** Double-asterisk emphasis only (avoids list-marker single `*` before prices). */
const MARKDOWN_BOLD = /\*\*([^*]+)\*\*/g;

/**
 * Renders `**bold**` segments in assistant text. Other markdown is left literal.
 */
export function renderMarkdownBoldSegments(text: string, keyPrefix: string): React.ReactNode[] {
  if (!text) {
    return [];
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let index = 0;

  const regex = new RegExp(MARKDOWN_BOLD.source, 'g');
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      React.createElement('strong', { key: `${keyPrefix}-bold-${index}` }, match[1])
    );
    index += 1;
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length ? parts : [text];
}
